import {
  diffRomTargets,
  RomTargetIdentity,
} from '@shared/components/rom-target-editor/rom-target-editor.utils';

/** A PATCH for a row the server already has, keyed by its id. */
export interface PendingRomTargetUpdate {
  id: number;
  goalDegrees: number;
}

export interface PendingRomTargetsPlan<T> {
  create: T[];
  update: PendingRomTargetUpdate[];
  delete: number[];
}

/**
 * What the form still needs to write, given GET /rom-targets. Thin wrapper
 * around the shared `diffRomTargets` (also used by the member-profile tab's
 * save) — the diff itself must not be reimplemented per caller, see that
 * function's doc comment for why.
 *
 * A previous Save may have persisted some rows before a sibling 400 — the
 * server is the record of that, not a client-side success log. Same key with
 * a different goal is an update: identity-only dedupe would toast success
 * and leave the edited value on the server. A saved row missing from
 * `wanted` is a row the user removed from the editor between a failed Save
 * and the retry: leaving it out of the plan would orphan it on the server
 * forever, still counted in every future GET.
 */
export function pendingRomTargets<T extends RomTargetIdentity>(
  wanted: T[],
  existing: Array<RomTargetIdentity & { id: number }>,
): PendingRomTargetsPlan<T> {
  return diffRomTargets(existing, wanted);
}
